import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormButton } from 'src/app/components/form-button/form-button.component';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-store-priority',
  standalone: false,
  templateUrl: './store-priority.component.html',
  styleUrls: ['./store-priority.component.scss']
})
export class StorePriorityComponent implements OnInit {

  // store selection variables
  storeUrl = 'store/lookup';
  priorityButton: FormButton = new FormButton('Set Priority','');
  selectedStores: Array<number> = [];
  selectStoreForm: FormGroup;

  // Store in priority variables
  storesInPriority: Array<Store> = [];

  constructor(private formBuilder: FormBuilder, private apiHelper: ApiService) {
    this.selectStoreForm = this.formBuilder.group({
      selectedStore: [[], Validators.required]
    });
  }

  ngOnInit() {
    this.obtainStoresInPriority();
    this.setupFormValidation();
  }

  obtainStoresInPriority() {
    this.apiHelper.getABCisRequest<Array<Store>>(ABCisApi.Support, 'store/priority-list')
      .then((response) => {
        this.storesInPriority = response.body || [];
      })
      .catch((error) => {
        console.error('Error loading stores in priority:', error);
        this.storesInPriority = [];
      });
  }

  setValue(event: number[]) {
    console.log('Store selection changed:', event);
    this.selectedStores = event || [];

    // Update form control value
    this.selectStoreForm.patchValue({
      selectedStore: this.selectedStores
    });
  }

  setPriority() {
    if (this.selectedStores && this.selectedStores.length > 0) {
      this.priorityButton.setSubmit('Setting Priority...');

      const unwrapped = this.unwrapArray(this.selectedStores);

      this.apiHelper.postABCisRequest(ABCisApi.Support, `store/add-to-priority?storeIds=${unwrapped}`)
        .then((response) => {
          this.priorityButton.setSuccess('Priority Set!');
          this.obtainStoresInPriority();
          this.resetForm();

          // Reset button after 2 seconds
          setTimeout(() => {
            this.priorityButton.setDefault();
          }, 2000);
        })
        .catch((error) => {
          console.error('Error setting priority:', error);
          this.priorityButton.setError('Error', 'Failed to set priority');

          // Reset button after 3 seconds
          setTimeout(() => {
            this.priorityButton.setDefault();
          }, 3000);
        });
    } else {
      console.warn('No stores selected');
    }
  }

  resetForm() {
    this.selectedStores = [];
    this.selectStoreForm.reset();
    this.selectStoreForm.patchValue({
      selectedStore: []
    });
  }

  unwrapArray(selectedStores: number[]) {
    return selectedStores.join(',');
  }

  removePriority(storeId: number) {
    this.apiHelper.postABCisRequest(ABCisApi.Support, `store/remove-from-priority?storeIds=${storeId}`)
      .then((response) => {
        this.obtainStoresInPriority();
      })
      .catch((error) => {
        console.error('Error removing priority:', error);
      });
  }

  removeAllPriority() {
    if (this.storesInPriority && this.storesInPriority.length > 0) {
      const storeIds = this.storesInPriority.map(store => store.storeId);

      this.apiHelper.postABCisRequest(ABCisApi.Support, `store/remove-from-priority?storeIds=${storeIds.join(',')}`)
        .then((response) => {
          this.obtainStoresInPriority();
        })
        .catch((error) => {
          console.error('Error removing all priorities:', error);
        });
    }
  }

  private setupFormValidation() {
    // Enable/disable the form button based on form validity
    this.selectStoreForm.statusChanges.subscribe(status => {
      if (status === 'VALID' && this.selectedStores.length > 0) {
        this.priorityButton.ButtonStatus = 'enabled';
      } else {
        this.priorityButton.ButtonStatus = 'disabled';
      }
    });

    // Also watch for changes in selectedStores
    this.selectStoreForm.get('selectedStore')?.valueChanges.subscribe(value => {
      if (value && value.length > 0) {
        this.priorityButton.ButtonStatus = 'enabled';
      } else {
        this.priorityButton.ButtonStatus = 'disabled';
      }
    });
  }
}

class Store {
  storeId: number;
  storeName: string;
}
